import { useEffect } from 'react';
import { useRouter } from 'next/router';

import { Link } from 'aresui';
import { useBoolean, useWindowSize } from 'codekit';

import * as Icons from 'icons';

import { HeaderContainer } from './styles';

function Header() {
	// Hooks
	const router = useRouter();
	const { isMobile } = useWindowSize();

	// Boolean hooks
	const isActiveMobileMenu = useBoolean();

	// Effects
	useEffect(() => {
		if (isActiveMobileMenu.value) document.body.classList.add('active');
		else document.body.classList.remove('active');
	}, [isActiveMobileMenu.value]);

	useEffect(() => {
		router.prefetch('/');
	}, [router]);

	return (
		<HeaderContainer id="header">
			<div className="content">
				<h1 onClick={() => router.push('/')}>
					<Icons.CodeTagIcon />
				</h1>

				<nav className={isActiveMobileMenu.value ? 'active' : ''}>
					<ul>
						<li>
							<Link to="/contact">Contato</Link>
						</li>

						<li>
							<a
								href="https://github.com/jefferson-calmon"
								target="_blank"
								rel="noreferrer"
							>
								GitHub <Icons.FiExternalLink />
							</a>
						</li>

						<li>
							<a
								href="https://www.linkedin.com/in/jeffersoncalmon/"
								target="_blank"
								rel="noreferrer"
							>
								Linkedin <Icons.FiExternalLink />
							</a>
						</li>
					</ul>
				</nav>

				{isMobile && (
					<div id="menu-burger">
						<label htmlFor="check">
							<input
								type="checkbox"
								id="check"
								onChange={isActiveMobileMenu.toggle}
							/>
							<span></span>
							<span></span>
							<span></span>
						</label>
					</div>
				)}
			</div>
		</HeaderContainer>
	);
}

export default Header;
